<button type="button" class="p-1 border-solid focus:outline-none focus:shadow-outline focus:ring-0 flex items-center">

  <span *ngIf="currentVisibilityState === states.visible" [innerHtml]="closedEyeSvg | safeSvg"
    (click)="onVisibilityToggleChanged(states.hidden)"></span>

  <span *ngIf="currentVisibilityState === states.hidden" [innerHtml]="openEyeSvg | safeSvg"
    (click)="onVisibilityToggleChanged(states.visible)"></span>
</button>
